import { NgModule } from '@angular/core';

import { ControlErrorFactoryService } from '@svg-frontends/error/services/control-error-factory.service';

@NgModule({
	providers: [
		{ provide: ControlErrorFactoryService, useClass: ControlErrorFactoryService },
		// TODO maybe add provider stuff for errorMessageFactory or SvgErrorMessageFactory
	],
})
export class ErrorMessageModule {}
